import { ConnectionPositionPair } from '@angular/cdk/overlay';

export class PopupTooltipPositions
{
    public static defaultPositions: ConnectionPositionPair[] =
    [
        /* center/above */
        {
            originX: 'center',
            overlayX: 'center',
            originY: 'top',
            overlayY: 'bottom'
        },
        /* left/center */
        {
            originX: 'start',
            overlayX: 'end',
            originY: 'center',
            overlayY: 'center'
        },
        /* left/above*/
        {
            originX: 'start',
            overlayX: 'start',
            originY: 'top',
            overlayY: 'bottom'
        },
        /* above  right*/
        {
            originX: 'end',
            overlayX: 'end',
            originY: 'top',
            overlayY: 'bottom'
        },
        /* below */
        {
            originX: 'center',
            overlayX: 'center',
            originY: 'bottom',
            overlayY: 'top'
        },
        /* below left */
        {
            originX: 'start',
            overlayX: 'start',
            originY: 'bottom',
            overlayY: 'top'
        },
        /* below right */
        {
            originX: 'end',
            overlayX: 'end',
            originY: 'bottom',
            overlayY: 'top'
        },
        // /* right */
        // {
        //     originX: 'end',
        //     originY: 'center',
        //     overlayX: 'start',
        //     overlayY: 'center'
        // }
    ];
}
